import { useNavigate } from "react-router-dom";
import translatedHeading from "../utils/util";
import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import "../styles/App.css";

const Guru = (guru) => {
  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  const navigate = useNavigate();
  const guruData = guru.data;

  const handleCardClick = () => {
    navigate(`/gurus/${guruData.id}`, {
      state: {
        description: JSON.parse(guruData.description),
        image: guruData.image,
        name: guruData.name,
        name_hindi: guruData["name-hindi"],
      },
    });
  };
  let prakatyaDiwasText = translatedHeading("Prakatya diwas");
  let brahmleenDiwasText = translatedHeading("Brahmleen diwas");
  let presentGuruText = translatedHeading("Present Guru");
  return (
    <div className="guru-card" onClick={handleCardClick}>
      <img
        className="guru-image"
        src={`data:image/jpg;base64,${guruData.image}`}
        alt={guruData.name}
        height="100%"
        width="300px"
      />
      {guruData.presentGuru && (
        <p className="present-guru">{presentGuruText}</p>
      )}
      <div className="guru-name">
        {currentLanguage === "en" ? guruData.name : guruData["name-hindi"]}
      </div>
      {!guruData.presentGuru && (
        <>
          <div className="guru-prakatya-date">
            {prakatyaDiwasText}: {guruData.prakatyaDiwas}
          </div>
          <div className="guru-brahmleen-date">
            {brahmleenDiwasText}: {guruData.brahmleenDiwas}
          </div>
        </>
      )}
    </div>
  );
};
export default Guru;
